export default __webpack_public_path__ + "static/media/lf2.56d3a862.jpg";